module.exports = __webpack_public_path__ + "static/elizabeth-suit-c4ac9c3118de9a96bc3a2d4e5ef3ee51.jpg";